// import external dependencies
import 'jquery';
import 'consent_for_cookie';

window.getConsent({
  cookies: {
    page: "/cookies",
  },
  ui: {
    main_color: "#2cce82",
    button_color: "#1e61ff",
    text: {
      accept: "Understood",
      main: "We use cookies to make your experience better. By using our services, you agree to our use of cookies.",
    },
  },
});

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// resources/assets/scripts/main.js